import { IUserAutocompleteOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-option.model';
import {
  UserAutoCompleteCallOptionType,
  UserAutoCompleteCallOptionTypeIconsMap,
} from '@nimbus-library/features/shared/services/user-search/models/user-auto-complete-value-type';
import { IUserAutoCompleteCallOption } from '@nimbus-library/features/shared/components/material/input-user-autocomplete/i-user-auto-complete-value.model';
import { InitialsPipe } from '@nimbus-library/features/shared/pipes/initials.pipe';
import { IContact } from '@nimbus-library/features/shared/models/contacts/i-contact.model';

export class ContactSearchMapper {
  private readonly initialPipe = new InitialsPipe();
  public handle(contact: IContact): IUserAutocompleteOption {
    const userOption: IUserAutocompleteOption = {
      image: contact.iconPath,
      id: contact.id,
      initials: contact.initials || this.initialPipe.transform(contact.displayName),
      name: contact.displayName,
      hasCallOptions: contact.businessPhones?.length > 0 || !!contact.mobilePhone,
      callOptions: [],
    };

    if (contact.userPrincipalName) {
      userOption.callOptions.push(
        this.mapCallOption(contact.id, contact.userPrincipalName, UserAutoCompleteCallOptionType.upn, contact.displayName),
      );
    }

    if (contact.mobilePhones?.length > 0) {
      const mappedPhones: IUserAutoCompleteCallOption[] = contact.mobilePhones.map((phone) =>
        this.mapCallOption(contact.id, phone, UserAutoCompleteCallOptionType.mobile, contact.displayName),
      );
      userOption.callOptions.push(...mappedPhones);
    } else if (contact.mobilePhone) {
      userOption.callOptions.push(
        this.mapCallOption(contact.id, contact.mobilePhone, UserAutoCompleteCallOptionType.mobile, contact.displayName),
      );
    }

    if (contact.businessPhones?.length > 0) {
      const mappedPhones: IUserAutoCompleteCallOption[] = contact.businessPhones.map((phone) =>
        this.mapCallOption(contact.id, phone, UserAutoCompleteCallOptionType.business, contact.displayName),
      );
      userOption.callOptions.push(...mappedPhones);
    }

    if (contact.homePhones?.length > 0) {
      const mappedPhones: IUserAutoCompleteCallOption[] = contact.homePhones.map((phone) =>
        this.mapCallOption(contact.id, phone, UserAutoCompleteCallOptionType.home, contact.displayName),
      );
      userOption.callOptions.push(...mappedPhones);
    }
    return userOption;
  }
  private mapCallOption(
    userId: string,
    phone: string,
    type: UserAutoCompleteCallOptionType,
    displayName?: string,
  ): IUserAutoCompleteCallOption {
    return {
      type,
      text: phone,
      isDisabled: false,
      icon: UserAutoCompleteCallOptionTypeIconsMap[type],
      userId,
      displayName,
    };
  }
}
